import classnames from "classnames";
import PropTypes from "prop-types";
import React from "react";
import BreadcrumbPill from "web/react/components/breadcrumb-pill/breadcrumb-pill";
import { AllSelectedFilterInfo, FilterClickHandler } from "web/types/feed-filters";
import { UniversalFilterOption } from "web/types/universal-filters";
import { getSelectedOptions } from "web/react/components/feeds-filters/hooks/use-filter-manager";
import styles from "./feeds-filters-breadcrumb-pills.css";

interface BreadcrumbPillProps {
    selectedFilterInfo: AllSelectedFilterInfo;
    onClick: FilterClickHandler;
    className?: string;
}

function BreadcrumbPills({
    className,
    onClick,
    selectedFilterInfo,
}: BreadcrumbPillProps): null | JSX.Element {
    let selectedOptions: UniversalFilterOption[] = getSelectedOptions(selectedFilterInfo);

    return (
        <ul className={classnames(styles.pills, className)}>
            {selectedOptions.map((option) => (
                <li className={styles.pill} key={`${option.name}=${option.value}`}>
                    <BreadcrumbPill
                        onClick={(): void => onClick(option, true)}
                        title={option.label}
                        href={option.url}
                    />
                </li>
            ))}
        </ul>
    );
}

export default BreadcrumbPills;

BreadcrumbPills.propTypes = {
    selectedFilterInfo: PropTypes.object.isRequired,
    onClick: PropTypes.func.isRequired,
};
